import { BootcampActivityEventId } from '~/bootcamp/types/bootcamp.types'
import { getBootcampActivityEventsForCurrentRound, parseBootcampActivityEvents } from '~/bootcamp/utils/bootcamp.utils'
import { useAppSelector } from '~/redux/hooks'
import { selectCurrentRound } from '~/bootcamp/slices/bootcamp-activity.slice'

export default function useGetCollectedRewards(eventIds: BootcampActivityEventId[]): number {
  const currentRound = useAppSelector(selectCurrentRound)
  const events = getBootcampActivityEventsForCurrentRound(eventIds, currentRound)
  return new Set(events.map((elem) => `${elem.difficultyLevel}#${elem.rewardLevel}`)).size
}

export function useGetCollectedRewardSet(eventIds: BootcampActivityEventId[]): Set<number> {
  const events = parseBootcampActivityEvents(eventIds)
  const currentRound = useAppSelector(selectCurrentRound)

  const currentRoundEvents = events.filter((e) => e.round === currentRound)

  return new Set(currentRoundEvents.map((elem) => elem.rewardLevel))
}
